<mat-sidenav-container class="sidenav-container">
  <mat-sidenav mode="side" opened class="sidenav">
    <mat-nav-list>

      <div class="sidebar-logo-container">
        <a routerLink="/">
          <img src="images/DSDN_Images/desimonelogoblack.png" alt="DeSimone Logo" class="sidebar-logo">
        </a>
      </div>

      <a mat-list-item routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Home</a>

      <!-- Projects with toggle -->
      <mat-list-item *ngIf="canViewProjects() || canCreateProjects()" (click)="toggleSubmenu('projects')" class="submenu-toggle">
        <span>Projects</span>
        <mat-icon class="arrow" *ngIf="submenu['projects']">expand_less</mat-icon>
        <mat-icon class="arrow" *ngIf="!submenu['projects']">expand_more</mat-icon>
      </mat-list-item>
      <div *ngIf="submenu['projects'] && (canViewProjects() || canCreateProjects())" class="submenu">
        <a *ngIf="canViewProjects()" mat-list-item routerLink="/projects" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">View</a>
        <a *ngIf="canCreateProjects()" mat-list-item routerLink="/projects/create" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Create</a>
      </div>

      <!-- Invoices with toggle (COMMENTED OUT)
      <mat-list-item *ngIf="canViewInvoices() || canCreateInvoices()" (click)="toggleSubmenu('invoices')" class="submenu-toggle">
        <span>Invoices</span>
        <mat-icon class="arrow" *ngIf="submenu['invoices']">expand_less</mat-icon>
        <mat-icon class="arrow" *ngIf="!submenu['invoices']">expand_more</mat-icon>
      </mat-list-item>
      <div *ngIf="submenu['invoices'] && (canViewInvoices() || canCreateInvoices())" class="submenu">
        <a *ngIf="canViewInvoices()" mat-list-item routerLink="/invoices" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">View</a>
        <a *ngIf="canCreateInvoices()" mat-list-item routerLink="/invoices/create" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Create</a>
      </div>
      -->

      <!-- RFIs with toggle -->
      <mat-list-item *ngIf="canViewRfIs() || canCreateRfIs() || canCreateIQs()" (click)="toggleSubmenu('rfis')" class="submenu-toggle">
        <span>Requests</span>
        <mat-icon class="arrow" *ngIf="submenu['rfis']">expand_less</mat-icon>
        <mat-icon class="arrow" *ngIf="!submenu['rfis']">expand_more</mat-icon>
      </mat-list-item>
      <div *ngIf="submenu['rfis'] && (canViewRfIs() || canCreateRfIs() || canCreateIQs())" class="submenu">
        <a *ngIf="canViewRfIs()" mat-list-item routerLink="/requests" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">View</a>
        <a *ngIf="canCreateRfIs() || canCreateIQs()" mat-list-item routerLink="/requests/create" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Create</a>

      </div>

      <!-- EWOs with toggle (COMMENTED OUT)
      <mat-list-item *ngIf="canViewEwos() || canCreateEwos()" (click)="toggleSubmenu('ewos')" class="submenu-toggle">
        <span>EWOs</span>
        <mat-icon class="arrow" *ngIf="submenu['ewos']">expand_less</mat-icon>
        <mat-icon class="arrow" *ngIf="!submenu['ewos']">expand_more</mat-icon>
      </mat-list-item>
      <div *ngIf="submenu['ewos'] && (canViewEwos() || canCreateEwos())" class="submenu">
        <a *ngIf="canViewEwos()" mat-list-item routerLink="/ewos" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">View</a>
        <a *ngIf="canCreateEwos()" mat-list-item routerLink="/ewos/create" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Create</a>
      </div>
      -->
      
      <!-- Timesheet with toggle -->
      <mat-list-item *ngIf="canViewTimesheet()" (click)="toggleSubmenu('timesheet')" class="submenu-toggle">
        <span>Timesheet</span>
        <mat-icon class="arrow" *ngIf="submenu['timesheet']">expand_less</mat-icon>
        <mat-icon class="arrow" *ngIf="!submenu['timesheet']">expand_more</mat-icon>
      </mat-list-item>
      <div *ngIf="submenu['timesheet'] && canViewTimesheet()" class="submenu">
        <a *ngIf="canEditTimeSheet()" mat-list-item routerLink="/timesheet" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Edit</a>
        <a *ngIf="!canEditTimeSheet()" mat-list-item routerLink="/timesheet" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">View</a>
        <a *ngIf="canViewReport()" mat-list-item routerLink="/timesheet/report" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">View Report</a>
      </div>

      <!-- User managment with toggle -->
       <mat-list-item *ngIf="canEditRoles() || canAddUser()" (click)="toggleSubmenu('userManagement')" class="submenu-toggle">
        <span>User Management</span>
        <mat-icon class="arrow" *ngIf="submenu['userManagement']">expand_less</mat-icon>
        <mat-icon class="arrow" *ngIf="!submenu['userManagement']">expand_more</mat-icon>
      </mat-list-item>
      <div *ngIf="submenu['userManagement'] && (canEditRoles() || canAddUser())" class="submenu">
        <a *ngIf="canEditRoles()" mat-list-item routerLink="/roles/edit" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Manage Users</a>
        <a *ngIf="canAddUser()" mat-list-item routerLink="/user/add" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Add New User</a>
      </div>
    </mat-nav-list>

    <div class="sidenav-bottom">
      <a mat-flat-button href="https://help.dsdn.ca/#" target="_blank" rel="noopener noreferrer" class="help-btn">
        <mat-icon>help_outline</mat-icon>
        Help
      </a>
    </div>
  </mat-sidenav>

<mat-sidenav-content>
  <mat-toolbar class="app-toolbar">
    <div class="toolbar-left">
      <img src="images/DSDN_Images/dsdn_2.png" alt="DGDN Logo" class="toolbar-logo">
      <span class="toolbar-divider-vert"></span>
      <span class="toolbar-page">{{ activeSection }}</span>
    </div>

    <span class="toolbar-center">DeSimone Structural Detailing Network</span>

    <span class="spacer"></span>

    <div class="toolbar-right">
      <button
        *ngIf="authService.canSwitchCustomer()"
        type="button"
        class="switch-customer-btn"
        (click)="switchCustomer()"
      >
        <mat-icon>swap_horiz</mat-icon>
        <span>Switch customer</span>
      </button>

      <div class="toolbar-group toolbar-company-group">
        <img *ngIf="companyLogo" [src]="companyLogo" alt="Company Logo" class="company-logo" />
        <mat-icon *ngIf="!companyLogo" class="company-logo-fallback">business</mat-icon>
        <span class="company-name">{{ company }}</span>
      </div>

      <div class="toolbar-divider"></div>

      <button class="profile-btn" routerLink="/account">
        <img [src]="profilePhoto || user?.profilePhoto || 'images/profile-placeholder.png'" alt="Profile Photo" class="profile-avatar" />
        <span class="profile-name">{{ user?.firstname || 'Profile' }}</span>
      </button>

      <button class="logout-btn" (click)="logout()" aria-label="Sign out">
        <mat-icon>exit_to_app</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-content>


</mat-sidenav-container>
